// extracted by mini-css-extract-plugin
module.exports = {"center-preloader":"_1PwFp1-wDOYhmZm08SOZLY"};